import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useContext } from 'react';
import { ItemCartContext } from '../../CatalogItemCart.context';
import { getPrice } from '../../CatalogItemCart.utils';
function PriceSpan() {
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    priceString = _useState2[0],
    setPriceString = _useState2[1];
  var _useContext = useContext(ItemCartContext),
    item = _useContext.item,
    modifiers = _useContext.modifiers,
    selectedModifiers = _useContext.selectedModifiers,
    selectedVariation = _useContext.selectedVariation,
    quantity = _useContext.quantity;
  useEffect(function () {
    var variations = item.variations;
    var price = getPrice(variations, modifiers, selectedVariation, selectedModifiers, quantity);
    setPriceString(price);
  }, [item, modifiers, selectedModifiers, selectedVariation, quantity]);
  return /*#__PURE__*/React.createElement("span", null, priceString);
}
export default PriceSpan;